import type { JSX } from 'react'
import { monthLabel } from '../timeWindow'
import { CHART_INK } from './palette'

// The months a chart's window covers beyond the last month its data has. The
// axis keeps the full window so the chart answers "what do these months look
// like", and this zone answers it: nothing yet, as opposed to zero.
//
// A flat wash, deliberately NOT hatched: hatching already means "planned" or
// "pipeline" on these charts (the pipeline band, planned payroll), and an empty
// month is neither. The dashed rule marks the threshold, the same meaning the
// "projected" boundary on the cash position chart gives it.

// Roughly the label's width at the tick font size; narrower zones put the label
// to the left of the rule rather than letting it run off the plot.
const LABEL_ROOM = 110

export function NoDataZone({
  x,
  width,
  top,
  height,
  lastMonth,
}: {
  x: number
  width: number
  top: number
  height: number
  /** Last month the data covers; labels the rule. */
  lastMonth: string
}): JSX.Element {
  const inside = width >= LABEL_ROOM
  return (
    <g>
      <rect x={x} y={top} width={width} height={height} fill={CHART_INK.noData} />
      <line
        x1={x}
        x2={x}
        y1={top}
        y2={top + height}
        stroke={CHART_INK.axis}
        strokeDasharray="3 3"
      />
      <text
        x={inside ? x + 6 : x - 6}
        y={top + 11}
        textAnchor={inside ? 'start' : 'end'}
        className="tick"
      >
        {`Data ends ${monthLabel(lastMonth)}`}
      </text>
    </g>
  )
}
